import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Send, CheckCircle2 } from 'lucide-react';

interface LeadModalProps {
    isOpen: boolean;
    onClose: () => void;
    title?: string;
}

const LeadModal: React.FC<LeadModalProps> = ({ isOpen, onClose, title = "Agendar uma demonstração" }) => {
    const [step, setStep] = useState<'form' | 'success'>('form');
    const [loading, setLoading] = useState(false);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        // Simulating API call
        setTimeout(() => {
            setLoading(false);
            setStep('success');
        }, 1500);
    };

    return (
        <AnimatePresence>
            {isOpen && (
                <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.95, y: 20 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.95, y: 20 }}
                        className="relative w-full max-w-lg overflow-hidden rounded-[32px] border border-white/10 bg-[#0f1115] p-8 shadow-2xl"
                    >
                        <button 
                            onClick={onClose}
                            className="absolute right-6 top-6 text-white/30 hover:text-white"
                        >
                            <X size={24} />
                        </button>

                        {step === 'form' ? (
                            <div className="space-y-8">
                                <div className="space-y-2">
                                    <h3 className="text-3xl font-black tracking-tighter text-white">{title}</h3>
                                    <p className="text-secondary font-medium">Deixe seus dados e entraremos em contato em menos de 24h.</p>
                                </div>

                                <form onSubmit={handleSubmit} className="space-y-4">
                                    <div className="space-y-2">
                                        <label className="text-xs font-bold uppercase tracking-widest text-white/40">Nome do Contato</label>
                                        <input required type="text" placeholder="Ex: João Silva" className="w-full bg-white/[0.03] border border-white/10 rounded-2xl px-5 py-4 text-white focus:border-primary outline-none transition-all" />
                                    </div>
                                    <div className="space-y-2">
                                        <label className="text-xs font-bold uppercase tracking-widest text-white/40">E-mail Corporativo</label>
                                        <input required type="email" placeholder="joao@restaurante.com.br" className="w-full bg-white/[0.03] border border-white/10 rounded-2xl px-5 py-4 text-white focus:border-primary outline-none transition-all" />
                                    </div>
                                    <div className="space-y-2">
                                        <label className="text-xs font-bold uppercase tracking-widest text-white/40">WhatsApp</label>
                                        <input required type="tel" placeholder="(11) 99999-9999" className="w-full bg-white/[0.03] border border-white/10 rounded-2xl px-5 py-4 text-white focus:border-primary outline-none transition-all" />
                                    </div>

                                    <button 
                                        disabled={loading}
                                        className="group w-full flex items-center justify-center gap-2 bg-primary py-5 rounded-[22px] text-white font-black text-xl hover:bg-primary-hover transition-all disabled:opacity-50"
                                    >
                                        {loading ? "Enviando..." : "Enviar Solicitação"}
                                        {!loading && <Send size={20} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />}
                                    </button>
                                </form>
                            </div>
                        ) : (
                            <div className="py-12 text-center space-y-6">
                                <div className="mx-auto w-20 h-20 rounded-full bg-emerald-500/20 flex items-center justify-center text-emerald-400">
                                    <CheckCircle2 size={48} />
                                </div>
                                <div className="space-y-2">
                                    <h3 className="text-3xl font-black tracking-tighter text-white">Solicitação Enviada!</h3>
                                    <p className="text-secondary font-medium mx-auto max-w-xs">Sucesso. Nossa equipe entrará em contato com você pelo WhatsApp em breve.</p>
                                </div>
                                <button 
                                    onClick={onClose}
                                    className="px-8 py-3 rounded-full border border-white/10 text-white font-bold hover:bg-white/5 transition-all"
                                >
                                    Fechar
                                </button>
                            </div>
                        )}
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    );
};

export default LeadModal;
